import {http} from "@/http/axios";

export function getSyncTaskProcessApi(import_task_id) {
    return http({
        url: `/api/admin/import-sync-helper/getSyncTaskProcess`,
        method: 'GET',
        params: {
            import_task_id
        }
    })
}
